export class UnableToCreateClassRoomError extends Error {
  constructor() {
    super("Unable to create class room");

    Object.setPrototypeOf(this, new.target.prototype);
  }
}
